import {css, Global} from "@emotion/react/macro";
import styled from "@emotion/styled/macro";
import {PropsWithChildren, useContext, useEffect, useMemo, useState} from "react";
import {IVscMedia, IVscUrlSource, VscContext} from "./ContentRendererJSX";
import {useVscContext, VscReactContext} from "./VscReactContext";
import {Route, Routes, useNavigate, useParams} from "react-router-dom";
import useStation from "../../data/stationSource";
import * as React from "react";
import {useConfig, useIsAdmin, WantsAdminContext} from "../../config";
import DefaultLayout from "../layout/DefaultLayout";
import BackButtonLayout from "../layout/BackButtonLayout";
import {VscVideoControls} from "../video/VscVideoControls";
import {useVideoPlayerControls, useVideoPlayerStatus} from "../visualizer/VscVisualizerSession";
import {useUserContext} from "../../context/userContext";
import LogIn from "../screens/logIn/LogIn";
import LogInSearch from "../screens/logIn/LogInSearch";
import AccountFound from "../screens/logIn/AccountFound";
import {CreateAccountWrapper} from "../VscRoutes";
import {useLocationState, useQueryState} from "use-location-state";
import CreateAccount from "../screens/logIn/CreateAccount";
import Switch from "../screens/vscSiteSpecific/Switch";
import useSessionStorage from "../../hooks/useSessionStorage";


export const ContentDiv = styled.div`
  background-color: var(--content-background);
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  height: 100%;
  font-family: var(--font-name);

  h1,h2,h3,h4,p {
    margin: 0px 24px 0px 24px;
  }
  p {
    
    color: var(--secondary-text-color);
  }
  .subtitle1 {
    font-style: normal;
    font-weight: 300;
    font-size: 20px;
    line-height: 27px;
    letter-spacing: -0.017em;
  }
  .body1 {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    /* identical to box height */

    letter-spacing: -0.017em;

    /* Text/Primary Blue */

    color: var(--primary-color);
  }
  .body3 {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    /* identical to box height, or 129% */

    display: flex;
    align-items: center;

    /* Text/Seconday Gray */

    color: var(--secondary-text-color);
  }
  .vsc-title {
    text-align:center;
  }
  h1 {
    color: var(--primary-color, transparent);
    font-style: normal;
    font-weight: 400;
    font-size: 40px;
    line-height: 55px;
    /* identical to box height */

    letter-spacing: -0.017em;
    margin-top: 2rem;
    margin-bottom: 0.5rem;
    text-align: center;
  }

  h2 {
    color: var(--primary-text-color, transparent);
    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    line-height: 38px;
    letter-spacing: -0.017em;
    margin-bottom: 0;
    text-align: center;
  }

  em {
    font-style: normal;
  }

  

  .lg button {
    width: 374px;
    height: 472px;
  }
  .md button {
    img {
      width: 100px;
      margin:24px;
    }
    width: 335px;
    height: 340px;
  }
  .sm button {


    width: 275px;
    height: 232px;
  }
  & button.lg {
    width: 374px;
    height: 472px;
  }
  & button.md {
    width: 335px;
    height: 340px;
  }
  
  
  
`
export const ThemeCss: React.FC<{vscUrlSource:IVscUrlSource, theme:string}> = ({vscUrlSource, theme}) => {

  return <link rel={"stylesheet"} href={vscUrlSource.getHtmlContentUri("theme.css?shared=themes/" + encodeURIComponent(theme))}/>

}
export const VscTheme: React.FC<PropsWithChildren<{theme?:string}>> = (props) => {

  const vscContext = useContext(VscReactContext)!;
  const { theme } = props;

  if (!theme) return <>{props.children}</>;
  return <>
    <ThemeCss vscUrlSource={vscContext} theme={theme} />

    { props.children}
    </>;
}

export const VscCurrentValueContext = React.createContext<string>("");

export function useVscCurrentValue() {
  return useContext(VscCurrentValueContext)!;
}
const VscContentTitle = () => {

  const videoControls = useVideoPlayerControls();
  const videoStatus = useVideoPlayerStatus();

  return <>
    {videoStatus && <VscVideoControls
        videoControls={videoControls}
        videoStatus={videoStatus}/>
    }

  </>

}
const FullScreenDiv = styled.div`
  width:100%; height:100%;
> * {
  width:100%; height:100%;
}
`
export const VscFullScreenContent: React.FC<PropsWithChildren<{default?: string, includeBackButton?: boolean, theme:string}>> = (props) => {
  const config = useConfig();
  const { communityId } = useParams();
  const [currentValue, setCurrentValue] = useState<string|null>(null);

  const { includeBackButton } = props;
  const Wrapper = (includeBackButton ?? false) ? BackButtonLayout : React.Fragment;

  const currentValueToUse = currentValue ?? props.default ?? "";
  const vscContext = useMemo(() => new VscContext(config.server, config.contentServer, communityId,{

    setCurrentValue(val: string) {
      setCurrentValue(val);
    }

  }), [communityId, config.server, config.contentServer]);
  return <VscCurrentValueContext.Provider value={currentValueToUse}>
    <VscReactContext.Provider value={vscContext}>
      <VscTheme theme={props.theme}>
      <FullScreenDiv>
      <Wrapper>
        { props.children }
      </Wrapper>
      </FullScreenDiv>
      </VscTheme>
    </VscReactContext.Provider>
  </VscCurrentValueContext.Provider>

}
const VscContentLayout: React.FC<PropsWithChildren<{includeBackButton?: boolean, theme: string}>> = (props) => {
  const {includeBackButton} = props;
  const config = useConfig();
  //const [isAdmin, setIsAdmin] = useState<boolean>(false);


  const [wantsAdmin, setWantsAdmin] = useContext(WantsAdminContext);
  const canBeAdmin = config.isAdmin;


  const vscContext = useVscContext();
  const Right = canBeAdmin && <Switch checked={wantsAdmin} onChange={() => setWantsAdmin(!wantsAdmin)}>Admin</Switch>
  const Wrapper = (includeBackButton ?? true) ? BackButtonLayout : React.Fragment;

  return <DefaultLayout title={<VscContentTitle/>}
                   right={Right}
                   logoUrl={vscContext.getHtmlContentUri(`logo.png?shared=themes/${props.theme}`)}>
      <Wrapper>

        <ContentDiv>{props.children}</ContentDiv>
      </Wrapper>
    </DefaultLayout>;
}
const LoginFull: React.FC<{theme:string}> = ({theme}) => {
  const [login, setLogin ] = useQueryState("login", "");
  const [phone, setPhone] = useQueryState("phone", "");
  return  <LogIn theme={theme}>


    { login === "" && phone === "" && <LogInSearch onAccountFound={() => setLogin("account-found")} skipText={"Skip"} onCreateAccount={(community:string, phone:string) => setPhone(phone)} onSkipLogin={() => 0} /> }
    { login === "account-found" && <AccountFound onCompleteLogin={() => setLogin("") } /> }
    { phone !== "" && <CreateAccount searchedPhone={phone} onCompleteLogin={() => { setLogin(""); setPhone(""); }  }onCancel={(communityId:string) => setPhone("")}  /> }

  </LogIn>

}
const RequiresLoginWrapper: React.FC<PropsWithChildren<{requiresLogin:boolean, theme:string}>> = ({requiresLogin, children, theme}) => {
  const [login, setLogin ] = useQueryState("login", "");

  const { user } = useUserContext();

  const renderLoginPage = (requiresLogin && !user) || login === "account-found";
  return <Routes>
    <Route index element={renderLoginPage ? <LoginFull theme={theme} /> : children} />

  </Routes>

}
export const VscContent: React.FC<PropsWithChildren<{theme?:string, default?: string, includeBackButton?: boolean, requiresLogin?: boolean}>> = (props) => {

  const theme = props.theme ?? "bimaire";
  return <VscFullScreenContent default={props.default} theme={theme}>
    <VscContentLayout {...props} theme={theme}>
      <RequiresLoginWrapper theme={theme} requiresLogin={!!props.requiresLogin}>{ props.children }</RequiresLoginWrapper>
    </VscContentLayout>
  </VscFullScreenContent>
}


